import { callNative, isJDApp, isIOS } from '@jmfe/jd-jssdk';
import Xheader from '@jmfe/jm-xheader';

/** SDK 注册后启动；仅对 JD iOS 折叠设备试验返回店铺后的导航恢复。 */
export const observeDuoNavigationRecovery = () => {
  if (!isJDApp() || !isIOS()) return () => {};

  let disposed = false;
  let returnRequestId = 0;
  let wasVisible = document.visibilityState === 'visible';
  let hasLeftPage = false;
  const foldableDevice = Promise.resolve()
    .then(() => callNative('JDHybridScreenPlugin', 'isFoldable', {}, '0'))
    .then(({ status, data }) => (
      (status === '0' || status === '0000') && data && data.isFoldable === true
    ))
    .catch(() => false);

  const isCurrentReturn = requestId => (
    !disposed && requestId === returnRequestId && document.visibilityState === 'visible'
  );

  const handleVisibilityChange = () => {
    const visible = document.visibilityState === 'visible';
    if (visible === wasVisible) return;
    wasVisible = visible;
    const requestId = ++returnRequestId;
    if (!visible) {
      hasLeftPage = true;
      return;
    }
    // 首次显示不重配；每次离开再返回只执行一次。
    if (!hasLeftPage) return;
    hasLeftPage = false;

    foldableDevice.then(isFoldable => {
      if (!isFoldable || !isCurrentReturn(requestId)) return;
      return callNative('JDHybridContainerPlugin', 'getVisibleState', {}, '0').then(visibility => {
        // 按 SDK 契约，data 为 '1' 才表示当前容器可见；过期回包不能补发配置。
        if (
          !isCurrentReturn(requestId) ||
          (visibility.status !== '0' && visibility.status !== '0000') ||
          visibility.data !== '1'
        ) return;

        return Xheader({
          supportTran: '1',
          // Xheader 浅合并 tranParams，保留现有默认标题、背景和按钮颜色。
          tranParams: {
            whiteImg: '',
            blackImg: '',
            backgroundColor: '#ffffff',
            naviMenuType: 'wb',
            hideNavi: '0',
          },
        });
      });
    }).catch(() => {
      // 不支持或调用失败时保持原页面，不重试、不触发页面重载。
    });
  };

  document.addEventListener('visibilitychange', handleVisibilityChange);
  return () => {
    disposed = true;
    returnRequestId += 1;
    document.removeEventListener('visibilitychange', handleVisibilityChange);
  };
};
